import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  en: {
    appName: "Cerdik Tuition",
    tagline: "Attendance, records and fees — beautifully simple.",
    login: "Sign in",
    register: "Create account",
    email: "Email",
    password: "Password",
    fullName: "Full name",
    phone: "Phone number",
    logout: "Sign out",
    dashboard: "Dashboard",
    students: "Students",
    attendance: "Attendance",
    payments: "Payments",
    staff: "Staff",
    kiosk: "Kiosk mode",
    checkIn: "Check in",
    checkOut: "Check out",
    markAttendance: "Mark attendance",
    scanQR: "Scan office QR",
    myChildren: "My children",
    registerChild: "Register a child",
    saveChild: "Save child",
    level: "Class / Level",
    school: "School (optional)",
    dateOfBirth: "Date of birth",
    notes: "Notes",
    present: "Present",
    absent: "Absent",
    late: "Late",
    pay: "Pay",
    fees: "Fees",
    feePackages: "Fee packages",
    payFor: "Pay for",
    history: "History",
    total: "Total",
    role: "Role",
    admin: "Admin",
    parent: "Parent",
    teacher: "Teacher",
    staffRole: "Staff",
    welcome: "Welcome back",
    createUser: "Create user",
    users: "Users",
    location: "Location",
    face: "Face capture",
    geoRequired: "Location is required for Geo + Face check-in.",
    captureFace: "Capture face",
    recapture: "Retake",
    submit: "Submit",
    cancel: "Cancel",
    hello: "Hi",
    admin_dashboard_title: "Administrator control center",
    parent_dashboard_title: "Parent portal",
    teacher_dashboard_title: "Teacher workspace",
    staff_dashboard_title: "Staff workspace",
    kioskInstruction:
      "Type a staff email, capture face, then tap Check in / Check out.",
    parentScanInstruction:
      "Scan the office QR poster with your phone camera. Then confirm your child's check-in below.",
    wallQR: "Office wall QR",
    landingEditor: "Landing page",
    notifications: "Notifications",
    noNotifications: "No notifications yet.",
    classStartingSoon: "Online class starting soon",
    joinMeet: "Join Google Meet",
    feeOverdueNotif: "Overdue fee payment",
    payNow: "Pay now",
    print: "Print",
    noRecordsYet: "No records yet.",
    signInAsParent: "Sign in as a parent to check your kids in.",
    switchLanguage: "Bahasa Malaysia",
    timetable: "Timetable",
    addClass: "Add class",
    className: "Class name",
    day: "Day",
    startTime: "Start time",
    endTime: "End time",
    room: "Room",
    reports: "Reports",
    month: "Month",
    downloadCsv: "Download CSV",
    fees: "Fees",
    assignFee: "Assign fee",
    package: "Package",
    feeName: "Fee name",
    amount: "Amount",
    dueDate: "Due date",
    student: "Student",
    pending: "Pending",
    paid: "Paid",
    enrollment: "Enrollment",
    chooseClass: "Choose class",
    chooseStudent: "Choose student",
    enroll: "Enroll",
    receipt: "Receipt",
    downloadReceipt: "Download receipt",
    attendanceInsights: "Attendance insights",
    attendanceInsightsSub: "Monthly attendance pattern for each child at a glance.",
    presentDays: "Present days",
    lateDays: "Late days",
    absentDays: "Absent days",
    attendanceRate: "Attendance rate",
    markedDays: "days recorded",
    noAttendanceData: "No attendance recorded for this month.",
    selectChild: "Select child",
    autoInvoice: "Auto-invoice",
    autoInvoiceInfo: "Monthly reading class fees are generated automatically for every enrolled student on the 1st of each month (physical RM150, online RM120). You can also run it manually.",
    runAutoInvoice: "Generate this month's fees",
    invoicesCreated: "invoice(s) created",
    invoicesSkipped: "already existed",
    classReport: "Class report",
    classReportSub: "Monthly attendance summary per class — perfect before parent meetings.",
    classAverage: "Class average",
    totalStudents: "Students enrolled",
    markedDaysCol: "Days marked",
    rate: "Rate",
    progress: "Progress",
    classMode: "Class mode",
    physical: "Physical",
    online: "Online",
    meetingLink: "Meeting link",
    joinClass: "Join class",
  },
  ms: {
    appName: "Membaca PMM",
    tagline: "Kelas Program Membaca PMM — kehadiran, perkembangan dan yuran, mudah dan cantik.",
    login: "Log masuk",
    register: "Buka akaun",
    email: "E-mel",
    password: "Kata laluan",
    fullName: "Nama penuh",
    phone: "Nombor telefon",
    logout: "Log keluar",
    dashboard: "Papan pemuka",
    students: "Murid",
    attendance: "Kehadiran",
    payments: "Bayaran",
    staff: "Kakitangan",
    kiosk: "Mod kiosk",
    checkIn: "Daftar masuk",
    checkOut: "Daftar keluar",
    markAttendance: "Tanda kehadiran",
    scanQR: "Imbas QR pejabat",
    myChildren: "Anak-anak saya",
    registerChild: "Daftar anak",
    saveChild: "Simpan anak",
    level: "Kelas / Tahap",
    school: "Sekolah (pilihan)",
    dateOfBirth: "Tarikh lahir",
    notes: "Catatan",
    present: "Hadir",
    absent: "Tidak hadir",
    late: "Lewat",
    pay: "Bayar",
    fees: "Yuran",
    feePackages: "Pakej yuran",
    payFor: "Bayar untuk",
    history: "Sejarah",
    total: "Jumlah",
    role: "Peranan",
    admin: "Pentadbir",
    parent: "Ibu bapa",
    teacher: "Guru",
    staffRole: "Kakitangan",
    welcome: "Selamat kembali",
    createUser: "Cipta pengguna",
    users: "Pengguna",
    location: "Lokasi",
    face: "Imbasan wajah",
    geoRequired: "Lokasi diperlukan untuk daftar masuk Geo + Wajah.",
    captureFace: "Ambil wajah",
    recapture: "Ambil semula",
    submit: "Hantar",
    cancel: "Batal",
    hello: "Hai",
    admin_dashboard_title: "Pusat kawalan pentadbir",
    parent_dashboard_title: "Portal ibu bapa",
    teacher_dashboard_title: "Ruang kerja guru",
    staff_dashboard_title: "Ruang kerja kakitangan",
    kioskInstruction:
      "Taip e-mel kakitangan, ambil wajah, kemudian tekan Daftar masuk / Daftar keluar.",
    parentScanInstruction:
      "Imbas poster QR pejabat menggunakan kamera telefon. Kemudian sahkan daftar masuk anak anda di bawah.",
    wallQR: "QR dinding pejabat",
    landingEditor: "Landing page",
    notifications: "Notifikasi",
    noNotifications: "Belum ada notifikasi.",
    classStartingSoon: "Kelas online akan bermula",
    joinMeet: "Sertai Google Meet",
    feeOverdueNotif: "Yuran belum dibayar",
    payNow: "Bayar sekarang",
    print: "Cetak",
    noRecordsYet: "Belum ada rekod.",
    signInAsParent: "Log masuk sebagai ibu bapa untuk mendaftar anak.",
    switchLanguage: "English",
    timetable: "Jadual Kelas",
    addClass: "Tambah kelas",
    className: "Nama kelas",
    day: "Hari",
    startTime: "Masa mula",
    endTime: "Masa tamat",
    room: "Bilik",
    reports: "Laporan",
    month: "Bulan",
    downloadCsv: "Muat turun CSV",
    fees: "Yuran",
    assignFee: "Tugaskan yuran",
    package: "Pakej",
    feeName: "Nama yuran",
    amount: "Jumlah",
    dueDate: "Tarikh akhir",
    student: "Murid",
    pending: "Belum bayar",
    paid: "Sudah bayar",
    enrollment: "Pendaftaran kelas",
    chooseClass: "Pilih kelas",
    chooseStudent: "Pilih murid",
    enroll: "Daftar",
    receipt: "Resit",
    downloadReceipt: "Muat turun resit",
    attendanceInsights: "Analisis kehadiran",
    attendanceInsightsSub: "Corak kehadiran bulanan setiap anak sepintas lalu.",
    presentDays: "Hari hadir",
    lateDays: "Hari lewat",
    absentDays: "Hari tidak hadir",
    attendanceRate: "Kadar kehadiran",
    markedDays: "hari direkodkan",
    noAttendanceData: "Tiada kehadiran direkodkan untuk bulan ini.",
    selectChild: "Pilih anak",
    autoInvoice: "Invois automatik",
    autoInvoiceInfo: "Yuran kelas membaca bulanan dijana secara automatik untuk setiap pelajar berdaftar pada 1 haribulan setiap bulan (fizikal RM150, online RM120). Anda juga boleh jalankan secara manual.",
    runAutoInvoice: "Jana yuran bulan ini",
    invoicesCreated: "invois dicipta",
    invoicesSkipped: "sudah wujud",
    classReport: "Laporan kelas",
    classReportSub: "Ringkasan kehadiran bulanan setiap kelas — sesuai sebelum mesyuarat ibu bapa.",
    classAverage: "Purata kelas",
    totalStudents: "Murid berdaftar",
    markedDaysCol: "Hari direkod",
    rate: "Kadar",
    progress: "Perkembangan",
    classMode: "Mod kelas",
    physical: "Fizikal",
    online: "Online",
    meetingLink: "Pautan kelas",
    joinClass: "Sertai kelas",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "ms");
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);
  const t = (key) => dict[lang][key] || dict.en[key] || key;
  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
